<template>
    <div class="add-new-client">
        <md-dialog :md-active.sync="showDialog" >          
          <md-dialog-title>
              <span>New creative version </span>
              <button class="btn btn--close" @click="cancel"></button>
          </md-dialog-title>
          <validation-observer v-slot="{ handleSubmit }" tag="div" v-if="!error.uploaderr">
            <form @submit.prevent="handleSubmit(addNewCreative)" class="form">
              <div class="form__content">                                                               
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <md-field>                  
                      <label>Creative file</label>                  
                          <div class="md-file">
                            <input readonly="readonly" class="md-input" v-model="fileNamesToUpload" />
                            <input type="file" accept="image/*,application/pdf" @change="filesSelected" />
                          </div>                          
                    </md-field>
                    <div class="form__error" v-if="error.thumb">{{error.thumb}}</div>
                  <div class="form__error">{{ errors[0] }}</div>
                </ValidationProvider>                        
              </div>
              <md-dialog-actions v-if="!loading">
                <div class="md-layout">
                  <div class="md-layout-item">
                    <md-button class="md-primary modal-cancel-btn" @click="cancel">Cancel</md-button>
                  </div>
                  <div class="md-layout-item text-right">
                  <md-button class="md-primary modal-save-btn"  type="submit">Save Creative</md-button>
                  </div>
                </div>
              </md-dialog-actions>
            </form>
          </validation-observer>
          <!-- error msg -->
          <div v-else class="error-msg">{{error.uploaderr}}</div>
        </md-dialog>
        <button class="btn btn-green" @click="showDialog = true" ><img alt="Add Button" src="@/assets/img/icons/add.svg" class="addButton"> Add new version </button>  
        
        
    </div>
</template>


<script>
import apiHandlerMI from "@/mixins/apiHandlerMI.js";
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {required} from 'vee-validate/dist/rules';
import {setInteractionMode} from 'vee-validate';

setInteractionMode('eager');
extend('required', {
  ...required,
  message: "File need to upload."
});

export default {
  props:['board','creative'],
  mixins: [apiHandlerMI],
  data(){
    return{
      showDialog: false,
      active: false,
      new: {
          thumb: false,
          creative_file: false,
      },
      error: {},
      loading : false,
      needUpload : false,
      type: this.creative.type,
      filesToUpload: null,
      fileNamesToUpload: undefined,
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
    methods:{
      filesSelected(event) {
        this.needUpload = true;
        this.new.thumb = undefined;
        this.filesToUpload = event.target.files;
        this.fileNamesToUpload = this.filesToUpload[0].name
      },
      upload_selected: function(num = 0) {
        if (!this.needUpload)
          return false;
        const _this = this;
        if (!(this.filesToUpload || []).length) {
          
          this.error.thumb = "Image required!";
          this.$forceUpdate();
          return;
        }
        if (!this.type) {
          this.error.thumb  = "Type required!";
          this.$forceUpdate();
          return;
        }
         this.error.thumb  = undefined;
        if (this.filesToUpload.length <= num) {
          this.fileNamesToUpload = undefined;
          //this.uploadSuccess = `You have successfully uploaded ${num} files`;
          setTimeout(() => {
            _this.uploadSuccess = undefined;
          }, 3000);
          return;
        }

        let file = this.filesToUpload[num];

        const formData = new FormData();
        formData.append("files[0]", file);
        formData.append("payment_cluster_id", this.creative.payment_cluster_id);
        formData.append("folder",'brands');
        formData.append("upload_type", 'no_size');

        var url = "image";
       if (this.creative.type == 'pdf' && this.filesToUpload[num].type == "application/pdf")
        {
          url = 'document'
          formData.append("pdf_image", 1);
        }
        this.post(
          "filemanager/upload/" + url,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          },
          function(resp) {

            if (_this.creative.type == 'pdf')
            {
                _this.new.thumb =  resp.data.documents[0].pdf_image.image
                _this.new.creative_file  =resp.data.documents[0]
            }
            else
            {
                 _this.new.thumb = resp.data.images[0]
                 _this.new.creative_file  = resp.data.images[0]
            }
            _this.needUpload = false;
            

            _this.addNewCreativeData();
            //_this.upload_selected(num + 1);
          }, function(){
            _this.error.uploaderr = 'Something went wrong! The document upload is failed.';            
          }
        );
      },
      addNewCreative(){
        this.loading  =true;
        this.upload_selected();        
      },
      addNewCreativeData(){
          var _this = this;
        
        
        this.post('creative',{
                width: this.creative.width,
                thumb: this.new.thumb.id,
                board_id: this.creative.board_id,
                creative_file: this.new.creative_file.id,
                height: this.creative.height,
                type: this.creative.type,
                parent_id : 0, 
                status: 'draft',
                comment_status: 'account',
                version: parseInt(this.creative.version) + 1, 
        },{},function(resp){            
              
            //  _this.addLog({
            //     creative_id: _this.creative.id,
            //     creative_name: _this.creative.type,
            //     board_id: _this.creative.board.id,
            //     board_name: _this.creative.board.name,
            //     campaign_id: _this.creative.board.campaign_id,
            //     campaign_name: _this.creative.board.campaign.name,
            //     brand_id: _this.brand.id,
            //     brand_name: _this.brand.name,
            //     client_id: _this.brand.client.id,
            //     client_name: _this.brand.client.name,
            //     action: "New Version Added",
            //     user_id: _this.$store.state.user.id,
            //     user_name: _this.$store.state.user.name
            // },function(){
            //   _this.refreshTimeline();
            // })

            
            
          _this.put('creative/'+_this.creative.id,{
               parent_id : resp.data.result.creative.id,
               board_id: _this.board.id
          },{},function(){
            // refreshBrand commented because of console.log bug and it isn't necessary
              // if (_this.$parent.refreshBrand)
              //    _this.$parent.refreshBrand();
             
              if (_this.$parent.refreshBoard)
                 _this.$parent.refreshBoard();
                 setTimeout(function(){
                   _this.$parent.selectCreativeById(resp.data.result.creative.id)
                 },2000)
                //set the default state
                _this.setDefaultState()               
          })
                   
        },function(resp){
          console.log(resp);
          _this.error = resp.data.error;
          this.$forceUpdate();
        })
      },
      cancel(){
        this.setDefaultState()
      },
      setDefaultState(){
        this.showDialog = false        
        this.error.uploaderr = undefined
        this.loading = false
        this.filesToUpload = null
        this.fileNamesToUpload = undefined
        this.needUpload = false;
      }
    }
 }

</script>